import React from "react";
import Progress from "../components/progress";

const ProgressCollection = () => (
  <section className="content">
    <div className="page-group">
      <div className="progress-bars" id="progress">
        <Progress end={90} title={"HTML"} color={`rgba(100, 200, 120, 1)`} />

        <Progress end={85} title={"CSS"} color={`rgba(30, 200, 120, 1)`} />

        <Progress end={70} title={"JS"} color={`rgba(222, 156, 11, 1)`} />

        <Progress end={80} title={"React"} color={`rgba(11, 148, 222, 1)`} />

        <Progress end={70} title={"Redux"} color={`rgba(11, 148, 238, 1)`} />

        <Progress end={60} title={"Rails"} color={`rgba(235, 101, 91, 1)`} />

        <Progress end={40} title={"Ruby"} color={`rgba(255, 101, 91, 1)`} />

        <Progress end={95} title={"Git"} color={`rgb(255, 72, 127)`} />
      </div>
    </div>
  </section>
);

export default ProgressCollection;
